import { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { AuthContext } from "../context/AuthContext";
import { GoMail } from "react-icons/go";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosNotificationsOutline } from "react-icons/io";

import SendBulkEmail from "./admin/SendBulkEmail";
import BulkWhatsApp from "./admin/BulkWhatsApp";
import Modal from "./Modal";
import PushNotification from "./admin/PushNotification";

import { requestNotificationPermission } from "./config/firebaseConfig";
import NotificationPopup from "./admin/NotificationPopup";

const Header = () => {
  const { authState, setAuthState } = useContext(AuthContext); // Access context here
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // For controlling dropdown visibility
  const [social, setSocial] = useState();
  const navigate = useNavigate(); // Hook to redirect after logout
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const openModal = (social) => {
    setSocial(social);

    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    requestNotificationPermission();
  });

  const [unreadCount, setUnreadCount] = useState(0);

  // ✅ Load unread notification count
  useEffect(() => {
    const count = localStorage.getItem("unreadCount") || "0";
    setUnreadCount(parseInt(count, 10));
  }, []);

  // ✅ Reset unread count when opening popup
  const handleBellClick = () => {
    setShowPopup(!showPopup);
    localStorage.setItem("unreadCount", "0"); // Clear unread count
    setUnreadCount(0);
  };

  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  // Logout the user and reset the auth state
  const onLogout = () => {
    // Clear the authState in context
    setAuthState({ isAuthenticated: false, token: null, user: null });

    // Clear the user token and details from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // Log the user out
    console.log("Logout clicked");

    // Redirect the user to the login page after logout
    navigate("/login");
  };

  // to get the initials of first name and last name
  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName?.charAt(0).toUpperCase() || "";
    const lastInitial = lastName?.charAt(0).toUpperCase() || "";
    return firstInitial + lastInitial;
  };

  return (
    <header className="bg-light bg-gradient modal-bg-fix">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <img width="100" src={logo} alt="Logo" />
            </Link>
            <div className="d-flex gap-3 p-2">
              {!authState.isAuthenticated ? (
                // If not authenticated, show login and register links
                <div className="hd-links d-flex gap-2 p-2">
                  <div className="nav-item">
                    <Link className="nav-link home-link" to="/login">
                      Sign In
                    </Link>
                  </div>
                  <div className="nav-item">|</div>
                  <div className="nav-item">
                    <Link className="nav-link home-link" to="/register">
                      Register
                    </Link>
                  </div>
                </div>
              ) : (
                <>
                  {authState.user.role === "admin" && (
                    <div className="d-flex gap-3 justify-content-center align-items-center">
                      <div className="hd-links">
                        <div className="nav-item cursor">
                          <GoMail onClick={() => openModal("sendBulkMail")} />
                        </div>
                      </div>
                      <div className="hd-links">
                        <div className="nav-item cursor">
                          <FaWhatsapp
                            onClick={() => openModal("sendBulkWhatsapp")}
                          />
                        </div>
                      </div>

                      <div className="hd-links d-flex gap-2">
                        <div className="nav-item not-icon">
                          <IoIosNotificationsOutline
                            onClick={() => openModal("pushNotify")}
                          />
                        </div>
                      </div>

                      {/*   <button onClick={requestNotificationPermission}>
                    Enable Notifications
                  </button> */}
                      <Modal
                        showModal={showModal}
                        onClose={closeModal}
                        pageTitle="Send Bulk Emails"
                      >
                        {/* <Register referralId={userData.id} pageTitle="Add New Member" /> */}
                        {/* <MemberRegister
                      referralId={userData.id}
                      
                    /> */}
                        {social === "sendBulkMail" ? (
                          <SendBulkEmail />
                        ) : social === "sendBulkWhatsapp" ? (
                          <BulkWhatsApp />
                        ) : social === "pushNotify" ? (
                          <PushNotification />
                        ) : null}
                      </Modal>
                    </div>
                  )}
                  {authState.user.role !== "admin" && (
                    <div>
                      <div className="hd-links d-flex justify-content-space-between align-items-center">
                        <div className="nav-item not-icon">
                          <button
                            onClick={handleBellClick}
                            className="bell-btn position-relative"
                          >
                            <IoIosNotificationsOutline />
                            {unreadCount > 0 && (
                              <span className="notify-count">
                                {unreadCount}
                              </span>
                            )}
                          </button>
                        </div>
                        {showPopup && (
                          <NotificationPopup
                            onClose={() => setShowPopup(false)}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* {showPopup && <NotificationPopup />} */}
                  {/* // If authenticated, show user dropdown */}
                  <div className={`dropdown ${isDropdownOpen ? "show" : ""}`}>
                    <div
                      className="cursor d-flex justify-content-center align-items-center"
                      onClick={toggleDropdown}
                      id="dropdownMenuButton"
                    >
                      <div>{`${authState?.user?.firstName}  ${authState?.user?.lastName}`}</div>
                      <button type="button" aria-expanded={isDropdownOpen}>
                        {/* Dynamically displaying the initials */}
                        {getInitials(
                          authState.user.firstName,
                          authState.user.lastName
                        )}
                      </button>

                      {/* <span className="ps-2">
                    {authState.user?.firstName + " " + authState.user?.lastName}
                  </span> */}
                    </div>
                    <ul
                      className={`dropdown-menu dropdown-menu-end ${
                        isDropdownOpen ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuButton"
                    >
                      {location.pathname === "/home" && (
                        <li>
                          <Link className="dropdown-item" to="/dashboard">
                            <i className="fa fa-cog me-2"></i>Dashboard
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link className="dropdown-item" to="/settings">
                          <i className="fa fa-cog me-2"></i>Settings
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" onClick={onLogout}>
                          <i className="fa fa-sign-out me-2"></i>Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
